export default "__VITE_ASSET__Cz8fDCs8__"